/**
 * DSFont — brand typography factories returning CSS font shorthand strings.
 *
 * The matching `@font-face` declarations live in `src/app/artist-ds.css` and
 * load `Mont` (heavy/extraLight) and `Smiley Sans` (genArt) from `/public/fonts`.
 */

const SYSTEM_FALLBACK =
	'-apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", system-ui, sans-serif';

/** Mont Heavy — brand display weight (800). */
export function montHeavy(size: number): string {
	return `800 ${size}px "Mont", ${SYSTEM_FALLBACK}`;
}

/** Mont ExtraLight — brand light weight (200). */
export function montExtraLight(size: number): string {
	return `200 ${size}px "Mont", ${SYSTEM_FALLBACK}`;
}

/** Smiley Sans — genArt display face (oblique). */
export function genArtHeavy(size: number): string {
	return `400 ${size}px "Smiley Sans", ${SYSTEM_FALLBACK}`;
}

/** Smiley Sans — genArt bold weight (650) for mid-emphasis labels. */
export function genArtBold(size: number): string {
	return `650 ${size}px "Smiley Sans", ${SYSTEM_FALLBACK}`;
}

/** Smiley Sans — genArt regular weight (400) for body / subtitle copy. */
export function genArtRegular(size: number): string {
	return `400 ${size}px "Smiley Sans", ${SYSTEM_FALLBACK}`;
}

export const DSFont = {
	montHeavy,
	montExtraLight,
	genArtHeavy,
	genArtBold,
	genArtRegular,
} as const;
